import { Component } from 'react';
import { Link } from 'react-router';

class Header extends Component {
  render() {
    return (
      <header>
        <div className="logo">
          <Link to="/">
            <img src={require('../../assets/images/logo.png')} srcSet={`${require('../../assets/images/logo.png')} 1x, ${require('../../assets/images/Logo@2x.png')} 2x`} alt="特定非営利活動法人 健やかネットワーク" />
          </Link>
        </div>
      </header>
    )
  }
}

export default Header;



/** WEBPACK FOOTER **
 ** ./src/components/modules/Header.js
 **/